import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import InfoPopover from 'Components/InfoPopover';
import HistoryHeader from 'Components/_NewElements/HistoryHeader';
import { mgadl } from 'neuro-schemas';
import { formatPartialDate } from 'Utility/date';

const { calculateScore } = mgadl;

const MGADLHistory = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => (
  <>
    <HistoryHeader
      headerText={<FormattedMessage id="functionalPerformanceMgravis.mgadl" />}
      buttons={[{ text: 'functionalPerformanceMgravis.newmgadl', onClick: startEdit({}, 'mgadl') }]}
    />
    <HistoryRowListing
      documents={documents}
      headers={
        <>
          <Item xs={2}>
            <FormattedMessage id="general.date" />
          </Item>
          <Item xs={2}>
            <FormattedMessage id="functionalPerformanceMgravis.mgadlScore" />
          </Item>
          <Item xs={8}>&nbsp;</Item>
        </>
      }
      contentFormat={d => (
        <>
          <Item xs={2}>{formatPartialDate(d.date)}</Item>
          <Item xs={2}>{calculateScore(d) ?? <InfoPopover text="general.notFilled" color="primary" />}</Item>
          <Item xs={5}>&nbsp;</Item>
          <Item xs={3}>
            <HistoryRowControls document={d} startEdit={startEdit} view={view} />
          </Item>
        </>
      )}
    />
  </>
);

interface IOwnProps {
  documents: IDocumentWithTypeV2<'mgadl'>[];
  startEdit: StartEdit;
  view?: IView;
}

export default MGADLHistory;
